export const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
        {
            '@type': 'Question',
            name: 'Wie kann ich das Matching nutzen?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Klicke auf „Kostenlos registrieren“, um ein kostenloses Konto zu erstellen. Wenn Du ein Pferdemensch bist, vervollständige dein Profil indem Du alle erforderlichen Informationen zu deinen Kenntnissen ausfüllst und deine Verfügbarkeit hinzufügst. Sobald dein Profil öffentlich erscheint, sind alle Matching-Funktionen für dich verfügbar.\n\nWenn Du Pferdebesitzer:in bist, kannst kostenlos ein Pferde-Inserat hochladen. Sobald dein Inserat geprüft und veröffentlicht wurde, sind alle Matching-Funktionen für dich verfügbar und Du kannst proaktiv nach Pferdemenschen suchen.',
            },
        },
        {
            '@type': 'Question',
            name: 'Wie zuverlässig ist das Matching?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Wir arbeiten täglich hart daran unseren Matching-Algorithmus zu verbessern. Unser Algorithmus basiert auf Daten aus deinem Profil oder Inserat. Achte darauf, dass Du alle Angaben gewissenhaft und vollständig ausfüllst, damit Du maximal von unseren Matching-Funktionen profitieren kannst. Einige Kriterien wie z. B. die Beschreibung können wir leider nicht einfliessen lassen. Hier lohnt es sich deshalb, wenn Du selbst vergleichst. Unter Umständen bieten einige Pferdemenschen oder Pferdebesitzer:innen Benefits, die eine höhere Übereinstimmung rechtfertigen.',
            },
        },
        {
            '@type': 'Question',
            name: 'Die Übersteinstimmung hat sich verändert, warum?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Manchmal ändern Pferdemenschen Angaben in ihrem Profil oder Pferdebesitzer:innen Angaben in ihrem Inserat, was die Übereinstimmung positiv oder negativ beeinflussen kann. ',
            },
        },
        {
            '@type': 'Question',
            name: 'Was kostet das Matching?',
            acceptedAnswer: {
                '@type': 'Answer',
                text:
                    'Unsere Matching-Funktionen kannst Du sofort nutzen, sobald Du ein Profil erstellt oder Inserat für dein Pferd veröffentlicht hast. Beides ist komplett kostenlos für dich. Also, worauf wartest Du noch? ',
            },
        },
    ],
};
